import { useEffect, useReducer } from 'react';
import {
  fieldsReducer,
  UPDATE_FIELD_VALUE,
  UPDATE_MULTIPLE_FIELD_VALUES,
  REFRESH_FIELD_VISIBILITY,
} from './fieldsReducer';

export const useFields = (initialFields = []) => {
  const [fields, dispatch] = useReducer(fieldsReducer, initialFields);

  const updateFieldValue = (id, value) => {
    dispatch({
      type: UPDATE_FIELD_VALUE,
      payload: { id, value },
    });
  };

  const updateMultipleFieldValues = (id, values) => {
    dispatch({
      type: UPDATE_MULTIPLE_FIELD_VALUES,
      payload: { id, values },
    });
  };

  const refreshFieldVisibility = () => {
    dispatch({
      type: REFRESH_FIELD_VISIBILITY,
      payload: {},
    });
  };

  // NOTE: Run this once to set visibility based on initial data
  useEffect(() => {
    refreshFieldVisibility();
  }, []); // Run only once on initial render.

  return { fields, updateFieldValue, updateMultipleFieldValues };
};
